import * as yup from 'yup';
import { parseAssignIdentityRoleIds } from './parseAssignIdentityContents';
import { AssignIdentityFormValues } from './types';

export const assignIdentityValidationSchema: yup.ObjectSchema<AssignIdentityFormValues> =
  yup.object({
    teamIds: yup
      .array()
      .of(yup.string().required())
      .default([])
      .min(1, 'Select at least one team'),
    contents: yup
      .array()
      .of(yup.string().required())
      .default([])
      .min(1, 'Select at least one role')
      .test(
        'has-role',
        'Select at least one role',
        value => parseAssignIdentityRoleIds(value ?? []).length > 0,
      ),
  });

export const DEFAULT_ASSIGN_IDENTITY_VALUES: AssignIdentityFormValues = {
  teamIds: [],
  contents: [],
};
